// Weight is optional on a pickup. Drivers weigh a producer's first pallets and the
// periodic re-baselines after that, and record no weight the rest of the time
// (BLI 48738), so ticket_detail.gross_weight arrives as null.
//
// A missing weight is not a weight of zero. Rendering it as 0.00 would read as
// "weighed and found to be nothing", so it renders as an em dash instead, and
// totals skip the lines that have no weight rather than treating them as zero.

export const NO_WEIGHT = '—';

/** True when a weight is present and numeric. Null, undefined, '' and NaN are not. */
export function hasWeight(value) {
    if (value === null || value === undefined || value === '') {
        return false;
    }
    return Number.isFinite(Number(value));
}

/** Two-decimal weight, or an em dash when the pallet was not weighed. */
export function formatWeight(value) {
    return hasWeight(value) ? Number(value).toFixed(2) : NO_WEIGHT;
}
